import {makeAutoObservable} from "mobx";
import {injectable} from "inversify";
import {ViewController} from "data/types/structure";
import {createFanHubEvent} from "data/utils/helpers";

export interface ILandingController extends ViewController {
	init(): void;
}

@injectable()
export class LandingController implements ILandingController {
	constructor() {
		makeAutoObservable(this);
	}

	init() {
		createFanHubEvent("fae58e9f-93db-4b1e-8909-f0f599f895f6");
	}

	dispose() {
		return;
	}
}
